import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { Row, Col } from 'react-bootstrap';
import HomePageStyle from './home-page.module.scss';

const AllInOneDashboard = () => (
  <StaticQuery
    query={graphql`
      query AllInOneDashboard {
        contentfulFsdHompage {
          homepageReference {
            sectionContent6 {
              subtitle {
                subtitle
              }
              sectionParagraph {
                json
              }
            }
          }
        }
      }
    `}
    render={(data) => (
      <div className={HomePageStyle.sectionDiv}>
        <Row className={HomePageStyle.section3Row}>
          <Col xs={12}>
            {/* Section6 Subtitle */}
            <h3 className={HomePageStyle.sectionTitle}>
              {
                data.contentfulFsdHompage.homepageReference.sectionContent6
                  .subtitle.subtitle
              }
            </h3>
            {/* Section6 Descriptive Paragraph */}
            <div className={HomePageStyle.sectionDescription}>
              {documentToReactComponents(
                data.contentfulFsdHompage.homepageReference.sectionContent6
                  .sectionParagraph.json
              )}
            </div>
          </Col>
        </Row>
      </div>
    )}
  />
);

export default AllInOneDashboard;
